import _ from 'lodash'
import StaticValue from '@/modules/common/values/staticValue'

export default _.range(4).map(value => new StaticValue(value, value + ''))
